let uniqid = +new Date();

export const writeTempStyleTag = (cssString) => {
	const id = `stag-temp-${uniqid++}`;
	const tag = document.createElement('style');
	tag.id = id;
	tag.innerText = cssString;
	document.head.appendChild(tag);
	return tag;
};

export const viewportWidth = () =>
	Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
